import { SpinnerSimple } from "../../spinner-simple"

import { SelectOptionLoaderContainer } from "./styles"

export const SelectOptionLoader = () => (
  <SelectOptionLoaderContainer>
    <SpinnerSimple color="lilac" size="auto" />
  </SelectOptionLoaderContainer>
)
